import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { SM_QUEUE_SERVER, TYPE_TRANSFER, BLOCKED_SETTING_TRANSFER } from "../constants/constants";
import { messageTransferCall, triggerNotifications } from "../Helpers/helperMessages";
import { Singleton } from "../Singletons/Singleton";

const language = new Singleton();

const makeBlindTransfer = (that, data) => {
  if (that.sharedData.getGeneralPermissions()[BLOCKED_SETTING_TRANSFER.ALL] === "0") {
    triggerNotifications(that, MESSAGE_CODE.BLIND_TRANSFER[10400], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  const transferNotification = language.getText('CallControlGUICallTransferBlindXferProcess');
  triggerNotifications(that, MESSAGE_CODE.BLIND_TRANSFER[10403], MESSAGE_TYPE.INFO, MESSAGE_FROM.CW, transferNotification);
  const transferMessage = messageTransferCall(data);
  that.sendToRabbit(SM_QUEUE_SERVER, transferMessage);
  that.sharedData.isBlindTranferActive = true;
}

export const makeSvrBlindTransferCallToAgent = (that, ext, callKey) => {

  const data = {
    acdID: that.sharedData.callIcon.CamEspId,
    callKey: callKey,
    array: "",
    typeTransfer: TYPE_TRANSFER.AGENT,
    camId: that.sharedData.callIcon.CamEspId,
    sPhone: that.sharedCallOutData.phone,
    dnis: "",
    extId: parseInt(ext),
  }

  makeBlindTransfer(that, data);
}

export const makeSvrBlindTransferCallToInboundCamp = (that, IdInboundCamp, callKey) => {
  const data = {
    acdID: IdInboundCamp,
    callKey: callKey,
    array: "",
    typeTransfer: TYPE_TRANSFER.INBOUND_CAMP,
    camId: that.sharedData.callIcon.CamEspId,
    sPhone: that.sharedCallOutData.phone,
    dnis: "",
    extId: 0,
  }

  makeBlindTransfer(that, data);
}

export const makeSvrBlindTransferCallToDirectory = (that, dirNumber, callKey) => {
  const data = {
    acdID: that.sharedData.callIcon.CamEspId,
    callKey: callKey,
    array: "",
    typeTransfer: TYPE_TRANSFER.DIRECTORY_OR_EXTERNAL_NUMBER,
    camId: that.sharedData.callIcon.CamEspId,
    sPhone: dirNumber,
    dnis: "",
    extId: 0,
  }
  
  makeBlindTransfer(that, data);
}

export const makeSvrBlindTransferCallToManualNumber = (that, manualNumber, callKey) => {
  const data = {
    acdID: that.sharedData.callIcon.CamEspId,
    callKey: callKey,
    array: "",
    typeTransfer: TYPE_TRANSFER.DIRECTORY_OR_EXTERNAL_NUMBER,
    camId: that.sharedData.callIcon.CamEspId,
    sPhone: manualNumber,
    dnis: "",
    extId: 0,
  }

  makeBlindTransfer(that, data);
}